import { createStore } from 'zustand-x';

export const useNotificationStore = createStore('pushNotification')(
  {
    isAlertResolved: '',
    didUserClickNotification: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  setIsAlertResolved: (newNotificationId: string) => {
    set.state((state) => ({
      ...state,
      notificationId: newNotificationId,
    }));
  },
  notificationTapped: () => {
    set.didUserClickNotification(true);
  },
  notificationNotTapped: () => {
    set.didUserClickNotification(false);
  },
}));
